(function() {
    angular
        .module('eAccess.ProviderPortal.Services.StatusStyles', [
            'eAccess.ProviderPortal.Constants.Status',
            'eAccess.ProviderPortal.Constants.Styles'
        ]);
})();
